import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import DatatableComponent from "../../helpers/DatatableComponent";
import moment from "moment";
import { Chip, Tooltip } from "@mui/material";
import { useState } from "react";
import { useHistory } from "react-router";

function FinanceProjects({ location, systemSettings }) {
  const mainBackground = systemSettings?.mainBackground;

  const history = useHistory();
  const [list, setList] = useState([]);
  const columns = [
    {
      name: "name",
      label: "Project Name",
    },
    {
      name: "budgetAmount",
      label: "Project Budget",
      options: {
        customBodyRender: (v) => v?.toLocaleString(),
      },
    },
    {
      name: "deliverables",
      label: "Deliverables",
      options: {
        customBodyRender: (v) => {
          return (
            <Tooltip
              title={
                <div className="flex flex-col bg-white p-2 text-black">
                  <div className="font-bold py-2" style={{ color: mainBackground }}>
                    Deliverables
                  </div>

                  <ol>
                    {v.map((d, i) => (
                      <li key={i}>
                        <p>
                          {" "}
                          <span className="font-bold text-primary">
                            {i + 1}. {d.title} ({d.amount})
                          </span>{" "}
                          - from {moment(d.startDate).format("YYYY-MMM-DD")} to{" "}
                          {moment(d.endDate).format("YYYY-MMM-DD")}
                        </p>
                        {d.extendedFrom && (
                          <>
                            <span className="text-xs text-gray-500">
                              <span style={{ color: mainBackground }}>Extended</span>{" "}
                              - from{" "}
                              {moment(d.extendedFrom).format("YYYY-MMM-DD")} to{" "}
                              {moment(d.extendedTo).format("YYYY-MMM-DD")}
                            </span>
                          </>
                        )}
                      </li>
                    ))}
                  </ol>
                </div>
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    boxShadow:
                      "3px 4px 6px rgba(0, 0, 0, 0.1), 2px 2px 4px rgba(0, 0, 0, 0.06)",
                    color: "black",
                    // minWidth: 120,
                  },
                },
              }}
            >
              <Chip
                size={"small"}
                className={"mr-1 my-2 shadow-md bg-primary"}
                label={v.length}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: "expenses",
      label: "Expenditure",
      options: {
        customBodyRender: (v) =>
          v?.reduce((a, b) => a + b.amount, 0).toLocaleString(),
      },
    },
    {
      name: "deliverables",
      label: "Expected Revenue",
      options: {
        customBodyRender: (v) =>
          v?.reduce((a, b) => a + b.amount, 0).toLocaleString(),
      },
    },
    {
      name: "id",
      label: "Estimated Profit",
      options: {
        customBodyRender: (v) => {
          const project = list.find((p) => p.id === v);
          return (
            project?.budgetAmount -
            project?.expenses.reduce((a, b) => a + b.amount, 0)
          ).toLocaleString();
        },
      },
    },
    // {
    //     name: "completedDeliverables",
    //     label: "Progress Status",
    //     options: {
    //         filter: true,
    //         sort: true,
    //         customBodyRenderLite: (id, index) => {
    //             let budget = list[index]?.budgetAmount !== 0;
    //             const completedDeliverables = list[index]?.completedDeliverables ?? 0
    //             let amount =
    //                 (completedDeliverables * 100) / list[index]?.budgetAmount;
    //             amount = Math.round(amount);
    //             return (
    //                 <div>
    //                     {" "}
    //                     {budget ? (
    //                         <Progress
    //                             max={100}
    //                             className={'bg-emerald-100'}
    //                             value={amount < 25 ? 25 : amount}
    //                         >
    //                             {amount}%
    //                         </Progress>
    //                     ) : null}
    //                 </div>
    //             );
    //         },
    //     },
    // },
    // {
    //     name: "paidAmount",
    //     label: "Payment Status(%)",
    //     options: {
    //         filter: true,
    //         sort: true,
    //         customBodyRenderLite: (id, index) => {
    //             let budget = list[index]?.budgetAmount !== 0;
    //             let amount =
    //                 (list[index]?.paidAmount * 100) / list[index]?.budgetAmount;
    //             amount = Math.round(amount);
    //             return (
    //                 <div>
    //                     {" "}
    //                     {budget ? (
    //                         <Progress
    //                             max={100}
    //                             className={'bg-emerald-100'}
    //                             value={amount < 25 ? 25 : amount}
    //                         >
    //                             {amount}%
    //                         </Progress>
    //                     ) : null}
    //                 </div>
    //             );
    //         },
    //     },
    // },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        customBodyRender: (v) => moment(v).format("YYYY-MMM-DD"),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        customBodyRender: (v) => moment(v).format("YYYY-MMM-DD"),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (v) => <Chip label={v} />,
      },
    },
  ];

  return (
    <div>
      <DatatableComponent
        columns={columns}
        elevation={1}
        title={`Projects (${
          location?.state?.startDate
            ? `From ${moment(location?.state?.startDate).format("DD/MM/yyyy")}`
            : ""
        } ${
          location?.state?.endDate
            ? `To ${moment(location?.state?.endDate).format("DD/MM/yyyy")}`
            : ""
        })`}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        onRowClick={(data, { rowIndex }) => {
          history.push(`/admin/project/details/${list[rowIndex].id}`);
        }}
        url={`/api/finance/dashboard/projects/?amountType=${
          location?.state?.currency ?? ""
        }&paymentStatus=${location?.state?.paymentStatus ?? ""}&startDate=${
          location?.state?.startDate ?? ""
        }&endDate=${location?.state?.endDate ?? ""}`}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FinanceProjects);
